<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-md-9">
                    <div class="mt-2 mb-2">
                        <strong>Plans</strong>
                    </div>
                </div>
                <div class="col-md-3">
                    <goback></goback>
                </div>
            </div>
            <form class="plan-add-form mb-3" @submit.prevent="addPlan">
                <div class="row">
                    <div class="col-md-2 form-group">
                        <label>Plan Code</label>
                        <input class="form-control" type="text" v-model="planForm.plan_code" placeholder="Plan code" />
                    </div>
                    <div class="col-md-2 form-group">
                        <label>Category</label>
                        <select class="form-control" v-model="planForm.category">
                            <option v-for="category in categoryList" v-bind:key="'category-' + category"
                                :value="category">{{ category }}</option>
                        </select>
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Name</label>
                        <input class="form-control" type="text" v-model="planForm.name"
                            placeholder="Name" />
                    </div>
                    <div class="col-md-2 form-group">
                        <label>Base Amount</label>
                        <input class="form-control" type="number" min="0" step="0.01" v-model="planForm.base_amount" />
                    </div>
                    <div class="col-md-2 form-group">
                        <label>Duration (days)</label>
                        <input class="form-control" type="number" min="1" step="1" v-model="planForm.duration_days" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-11 form-group">
                        <label>Description</label>
                        <input class="form-control" type="text" v-model="planForm.description"
                            placeholder="Description" />
                    </div>
                    <div class="col-md-1 form-group">
                        <label>&nbsp;</label>
                        <button type="submit" class="btn btn-primary btn-block" :disabled="isSaving">Add</button>
                    </div>
                </div>
            </form>
            <div class="table-responsive" v-dragscroll="!editingPlanCode">
                <table class="table table-bordered plans-table" v-if="plans.length > 0">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Plan Code</th>
                            <th>Category</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Base Amount</th>
                            <th>GST (%)</th>
                            <th>GST Amount</th>
                            <th>Total Amount</th>
                            <th>Currency</th>
                            <th>Duration (days)</th>
                            <th>Features</th>
                            <th>Active</th>
                            <th>Created At</th>
                            <th>Updated At</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(plan, index) in plans" v-bind:key="'plan-row-' + plan.plan_code">
                            <td>{{ index + 1 }}</td>
                            <td>{{ plan.plan_code }}</td>
                            <td>{{ plan.category }}</td>
                            <td>
                                <input v-if="isEditing(plan)" class="form-control input-sm" type="text"
                                    v-model="editForm.name" />
                                <span v-else>{{ plan.name }}</span>
                            </td>
                            <td>
                                <textarea v-if="isEditing(plan)" class="form-control input-sm" rows="3"
                                    v-model="editForm.description"></textarea>
                                <span v-else>{{ plan.description || "-" }}</span>
                            </td>
                            <td>
                                <input v-if="isEditing(plan)" class="form-control input-sm" type="number" min="0"
                                    step="0.01" v-model="editForm.base_amount" />
                                <span v-else>{{ formatAmount(plan.pricing.base_amount) }}</span>
                            </td>
                            <td>{{ plan.pricing.gst_percent }}</td>
                            <td>{{ formatAmount(plan.pricing.gst_amount) }}</td>
                            <td>{{ formatAmount(plan.pricing.total_amount) }}</td>
                            <td>{{ plan.currency }}</td>
                            <td>{{ plan.duration_days }}</td>
                            <td>{{ plan.features && plan.features.length ? plan.features.join(", ") : "-" }}</td>
                            <td>
                                <input v-if="isEditing(plan)" type="checkbox" v-model="editForm.is_active" />
                                <span v-else>{{ plan.is_active ? "Yes" : "No" }}</span>
                            </td>
                            <td>{{ formatDateTime(plan.created_at) }}</td>
                            <td>{{ formatDateTime(plan.updated_at) }}</td>
                            <td class="text-nowrap">
                                <template v-if="isEditing(plan)">
                                    <button type="button" class="btn btn-primary btn-sm" :disabled="isUpdating"
                                        @click="updatePlan">Save</button>
                                    <button type="button" class="btn btn-secondary btn-sm" :disabled="isUpdating"
                                        @click="cancelEdit">Cancel</button>
                                </template>
                                <button v-else type="button" class="btn btn-primary btn-sm"
                                    @click="startEdit(plan)">Edit</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else-if="!isLoading" class="text-center">No plans found</div>
            </div>
        </div>
    </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "@/assets/mixins/common.js";

export default {
    mixins: [commonMixins],
    created: function () {
        this.getPlans();
    },
    data: function () {
        return {
            isLoading: false,
            isSaving: false,
            plansApi: "/frontend/plan/list",
            addPlanApi: "/frontend/plan/add",
            updatePlanApi: "/frontend/plan/update",
            plans: [],
            categoryList: ["portal_access", "model_portfolio"],
            planForm: this.getEmptyPlanForm(),
            isUpdating: false,
            editingPlanCode: "",
            editForm: {}
        };
    },
    methods: {
        isEditing: function (plan) {
            return this.editingPlanCode === plan.plan_code;
        },
        startEdit: function (plan) {
            this.editingPlanCode = plan.plan_code;
            this.editForm = {
                name: plan.name || "",
                description: plan.description || "",
                base_amount: plan.pricing.base_amount,
                is_active: !!plan.is_active
            };
        },
        cancelEdit: function () {
            this.editingPlanCode = "";
            this.editForm = {};
        },
        updatePlan: function () {
            var form = this.editForm;
            var payload = {
                plan_code: this.editingPlanCode,
                name: String(form.name).trim(),
                description: String(form.description).trim(),
                base_amount: Number(form.base_amount),
                is_active: form.is_active
            };
            if (!payload.name) {
                this.$toastr.error("Name is required", "", {});
                return;
            }
            if (form.base_amount === "" || isNaN(payload.base_amount) || payload.base_amount < 0) {
                this.$toastr.error("Enter a valid Base Amount", "", {});
                return;
            }
            this.isUpdating = true;
            var myself = this;
            http.post(this.updatePlanApi, payload, function (error, response) {
                console.log("Update Plan response: ", response);
                myself.isUpdating = false;
                if (!error && response && response.status === "success") {
                    myself.$toastr.success("Plan updated successfully!", "", {});
                    myself.cancelEdit();
                    myself.getPlans();
                } else {
                    var message = (response && (response.message || response.status)) || "Failed to update plan";
                    myself.$toastr.error(message, "", {});
                }
            });
        },
        getEmptyPlanForm: function () {
            return {
                plan_code: "",
                category: "portal_access",
                name: "",
                description: "",
                base_amount: "",
                duration_days: ""
            };
        },
        addPlan: function () {
            var form = this.planForm;
            var payload = {
                plan_code: form.plan_code.trim(),
                category: form.category,
                name: form.name.trim(),
                description: form.description.trim(),
                base_amount: Number(form.base_amount),
                duration_days: parseInt(form.duration_days, 10)
            };
            if (!payload.plan_code || !payload.category || !payload.name) {
                this.$toastr.error("Plan Code, Category and Name are required", "", {});
                return;
            }
            if (form.base_amount === "" || isNaN(payload.base_amount) || payload.base_amount < 0) {
                this.$toastr.error("Enter a valid Base Amount", "", {});
                return;
            }
            if (isNaN(payload.duration_days) || payload.duration_days <= 0) {
                this.$toastr.error("Enter a valid Duration (days)", "", {});
                return;
            }
            this.isSaving = true;
            var myself = this;
            http.post(this.addPlanApi, payload, function (error, response) {
                console.log("Add Plan response: ", response);
                myself.isSaving = false;
                if (!error && response && response.status === "success") {
                    myself.$toastr.success("Plan added successfully!", "", {});
                    myself.planForm = myself.getEmptyPlanForm();
                    myself.getPlans();
                } else {
                    var message = (response && (response.message || response.status)) || "Failed to add plan";
                    myself.$toastr.error(message, "", {});
                }
            });
        },
        getPlans: function () {
            this.isLoading = true;
            var myself = this;
            http.post(this.plansApi, {"category": ""}, function (error, response) {
                console.log("Plans", response);
                if (!error && response && Array.isArray(response.data)) {
                    myself.plans = response.data.map(function (plan) {
                        var item = {};
                        for (var key in plan) {
                            if (Object.prototype.hasOwnProperty.call(plan, key)) {
                                item[key] = plan[key];
                            }
                        }
                        item.pricing = plan.pricing || {
                            base_amount: plan.base_amount,
                            gst_percent: plan.gst_percent,
                            gst_amount: 0,
                            total_amount: plan.base_amount
                        };
                        return item;
                    });
                } else {
                    myself.plans = [];
                }
                myself.isLoading = false;
            });
        },
        formatAmount: function (value) {
            return (Number(value) || 0).toFixed(2);
        },
        formatDateTime: function (value) {
            if (!value) {
                return "-";
            }
            var date = new Date(value);
            return isNaN(date.getTime()) ? value : date.toLocaleString();
        }
    }
};
</script>
<style>
.plans-table {
    font-size: 13px;
}

.plans-table th {
    background: #d8e2f2;
    color: #555;
    text-align: center;
    vertical-align: middle !important;
}

.plans-table td {
    text-align: center;
    vertical-align: middle !important;
    padding: 5px 10px 5px 10px;
}

.plans-table .form-control {
    font-size: 12px;
    height: auto;
    padding: 2px 6px;
}

.plans-table textarea.form-control {
    min-width: 200px;
    resize: vertical;
}

.plan-add-form label,
.plan-add-form .form-control,
.plan-add-form .btn {
    font-size: 12px;
}

.plan-add-form .form-control {
    height: 30px !important;
    padding: 4px 8px;
    line-height: 1.5;
}

.plan-add-form .btn {
    padding: 4px 8px;
}

.plans-table .btn-sm {
    font-size: 12px;
    padding: 2px 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/plans.vue